import { ModalFooter as NextUIModalFooter, ModalFooterProps as NextUIModalFooterProps } from "@heroui/react";

export interface ModalFooterProps extends NextUIModalFooterProps {}

export const ModalFooter = ({ children, ...props }: ModalFooterProps) => {
  return (
    <NextUIModalFooter {...props}>
      {children}
    </NextUIModalFooter>
  );
};
